(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;
  function money(cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.BCShopCurrency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  window.BCmoney = money;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.bc-rv:not([data-rv-done])');
    if (!els.length) return;
    document.documentElement.classList.add('bc-rv-on');
    if (RM || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-rv-done',''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-rv-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { el.setAttribute('data-rv-done',''); io.observe(el); });
  }

  function tilt(root) {
    if (RM || isTouch) return;
    (root || document).querySelectorAll('[data-bc-tilt]:not([data-tilt-done])').forEach(function (el) {
      el.setAttribute('data-tilt-done','');
      var max = parseFloat(el.getAttribute('data-bc-tilt')) || 3;
      var rx = 0, ry = 0, tx = 0, ty = 0, raf = null, active = false;
      function loop() {
        rx += (tx - rx) * 0.1; ry += (ty - ry) * 0.1;
        el.style.transform = 'perspective(1100px) rotateX(' + rx.toFixed(3) + 'deg) rotateY(' + ry.toFixed(3) + 'deg)';
        if (Math.abs(tx - rx) > 0.01 || Math.abs(ty - ry) > 0.01) { raf = requestAnimationFrame(loop); }
        else { raf = null; if (!active) el.style.transform = ''; }
      }
      function start() { if (!raf) raf = requestAnimationFrame(loop); }
      el.addEventListener('pointermove', function (e) {
        active = true;
        var r = el.getBoundingClientRect();
        ty = ((e.clientX - r.left) / r.width - 0.5) * 2 * max;
        tx = -((e.clientY - r.top) / r.height - 0.5) * 2 * max;
        start();
      });
      el.addEventListener('pointerleave', function () { active = false; tx = 0; ty = 0; start(); });
    });
  }

  function accordionInit(root) {
    (root || document).querySelectorAll('[data-bc-acc]:not([data-acc-done])').forEach(function (item) {
      item.setAttribute('data-acc-done','');
      var btn = item.querySelector('[data-bc-acc-btn]');
      var panel = item.querySelector('[data-bc-acc-panel]');
      if (!btn || !panel) return;
      var isOpen = item.classList.contains('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) panel.style.height = 'auto';
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        var single = item.closest('[data-bc-acc-single]');
        if (single && !open) {
          single.querySelectorAll('[data-bc-acc].is-open').forEach(function (o) {
            var p = o.querySelector('[data-bc-acc-panel]');
            o.classList.remove('is-open');
            o.querySelector('[data-bc-acc-btn]').setAttribute('aria-expanded','false');
            if (p) { p.style.height = p.scrollHeight + 'px'; requestAnimationFrame(function () { p.style.height = '0px'; }); }
          });
        }
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('is-open'); btn.setAttribute('aria-expanded','false');
        } else {
          item.classList.add('is-open'); btn.setAttribute('aria-expanded','true');
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName !== 'height') return;
            if (item.classList.contains('is-open')) panel.style.height = 'auto';
            panel.removeEventListener('transitionend', te);
          });
        }
      });
    });
  }

  function headerInit() {
    var hdr = document.querySelector('[data-bc-header]');
    if (hdr && !hdr.hasAttribute('data-hdr-done')) {
      hdr.setAttribute('data-hdr-done','');
      var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 12); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    var drawer = document.querySelector('[data-bc-drawer]');
    if (drawer && !drawer.hasAttribute('data-drw-done')) {
      drawer.setAttribute('data-drw-done','');
      var lastFocus = null;
      var open = function () {
        lastFocus = document.activeElement;
        drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
        document.body.style.overflow = 'hidden';
        var f = drawer.querySelector('a,button'); if (f) f.focus();
      };
      var close = function () {
        drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      };
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-bc-drawer-open]')) { e.preventDefault(); open(); }
        else if (e.target.closest('[data-bc-drawer-close]')) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = drawer.querySelectorAll('a[href],button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    function syncCount() {
      if (!bubble) return;
      var s = bubble.querySelector('.cart-count-bubble span');
      var n = s ? s.textContent.trim() : '0';
      document.querySelectorAll('[data-bc-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('bc-hidden', !n || n === '0');
      });
    }
    if (bubble && !bubble.hasAttribute('data-bc-obs')) {
      bubble.setAttribute('data-bc-obs','');
      new MutationObserver(syncCount).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
    if (!document.documentElement.hasAttribute('data-bc-cartbind')) {
      document.documentElement.setAttribute('data-bc-cartbind','');
      document.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        var b = e.target.closest('[data-bc-cart-open]');
        if (!b) return;
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); d.open(b); }
      });
    }
  }

  function annInit() {
    document.querySelectorAll('[data-bc-ann]:not([data-ann-done])').forEach(function (box) {
      box.setAttribute('data-ann-done','');
      var items = box.querySelectorAll('.bc-ann__item');
      if (!items.length) return;
      items[0].classList.add('is-on');
      if (items.length < 2 || RM) return;
      var i = 0;
      var speed = parseInt(box.getAttribute('data-bc-ann'), 10) || 4000;
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, speed);
    });
  }

  function bumpCount(count) {
    document.querySelectorAll('[data-bc-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.remove('bc-hidden');
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 560);
    });
  }

  function addToCart(variantId, quantity, btn) {
    var wrap = btn ? (btn.closest('[data-bc-form]') || btn.closest('[data-bc-add-scope]') || btn.parentElement) : null;
    var msg = wrap ? wrap.querySelector('[data-bc-atc-msg]') : null;
    if (msg) { msg.textContent = ''; msg.className = 'bc-atc__msg'; }
    if (btn) {
      btn.setAttribute('aria-busy','true');
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      btn.textContent = 'Wird hinzugefügt …';
    }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Das hat leider nicht geklappt.');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          bumpCount(cart.item_count);
          if (btn) {
            btn.classList.add('is-ok');
            btn.textContent = 'Hinzugefügt ✓';
            setTimeout(function () {
              btn.classList.remove('is-ok');
              if (btn.dataset.label) btn.textContent = btn.dataset.label;
            }, 1600);
          }
          if (drawer && res.json.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.json);
          } else if (msg) {
            msg.textContent = 'Zum Warenkorb hinzugefügt.'; msg.className = 'bc-atc__msg is-ok';
          }
          document.dispatchEvent(new CustomEvent('bc:cart:updated', { detail: cart }));
          return cart;
        });
      })
      .catch(function (err) {
        if (msg) { msg.textContent = err.message || 'Das hat leider nicht geklappt. Bitte erneut versuchen.'; msg.className = 'bc-atc__msg is-err'; }
        if (btn && btn.dataset.label) btn.textContent = btn.dataset.label;
      })
      .then(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          if (!btn.classList.contains('is-ok') && btn.dataset.label) btn.textContent = btn.dataset.label;
        }
      });
  }
  window.BCAddToCart = addToCart;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bc-add]');
    if (!el) return;
    if (el.type === 'submit' && el.closest('form')) return;
    e.preventDefault();
    var scope = el.closest('[data-bc-product]');
    var vid = el.getAttribute('data-variant-id');
    var qty = el.getAttribute('data-quantity') || 1;
    if (scope) {
      if (!el.hasAttribute('data-variant-id')) vid = scope.getAttribute('data-current-variant');
      if (!el.hasAttribute('data-quantity')) qty = scope.getAttribute('data-current-qty') || 1;
    }
    if (!vid) return;
    addToCart(vid, qty, el);
  });

  function productInit(root) {
    (root || document).querySelectorAll('[data-bc-product]:not([data-p-done])').forEach(function (scope) {
      scope.setAttribute('data-p-done','');
      var dataEl = scope.querySelector('[data-bc-product-json]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var variants = data.variants || [];
      if (!variants.length) return;
      var sizeSel = scope.querySelector('[data-bc-opt="size"]');
      var colorWrap = scope.querySelector('[data-bc-colors]');
      var qtyInput = scope.querySelector('[data-bc-qty]');
      var track = scope.querySelector('[data-bc-gal-track]');
      var thumbs = scope.querySelectorAll('[data-bc-gal-thumb]');
      var counter = scope.querySelector('[data-bc-gal-count]');
      var current = variants[0];

      function setActive(i) {
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-sel', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        if (counter && track) counter.textContent = (i + 1) + ' / ' + track.children.length;
      }
      function goTo(i) {
        if (!track) return;
        var slides = track.children;
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
        setActive(i);
      }
      function availableColors(g) { return variants.filter(function (v) { return v.group === g; }); }
      function renderColors() {
        if (!colorWrap) return;
        var g = sizeSel ? sizeSel.value : current.group;
        var list = availableColors(g);
        colorWrap.innerHTML = '';
        list.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bc-col__sw' + (v.id === current.id ? ' is-sel' : '');
          b.style.background = v.hex;
          b.setAttribute('aria-label', 'Farbe ' + v.color);
          b.setAttribute('aria-pressed', v.id === current.id ? 'true' : 'false');
          b.setAttribute('data-vid', v.id);
          if (!v.available) { b.style.opacity = '0.3'; b.title = v.color + ' – aktuell nicht verfügbar'; }
          colorWrap.appendChild(b);
        });
        var label = scope.querySelector('[data-bc-color-name]');
        if (label) label.textContent = current.color;
      }
      function renderBundles() {
        scope.querySelectorAll('[data-bc-bundle-row]').forEach(function (row) {
          var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
          var el = row.querySelector('[data-bc-bundle-price]');
          if (el && current) el.textContent = money(current.price * q);
        });
      }
      function setVariant(v) {
        if (!v) return;
        current = v;
        scope.setAttribute('data-current-variant', v.id);
        var p = scope.querySelector('[data-bc-price]');
        if (p) p.textContent = money(v.price);
        var cmp = scope.querySelector('[data-bc-compare]');
        if (cmp) {
          if (v.compare && v.compare > v.price) { cmp.textContent = money(v.compare); cmp.style.display = ''; }
          else { cmp.style.display = 'none'; }
        }
        scope.querySelectorAll('[data-bc-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
        var avail = scope.querySelector('[data-bc-avail]');
        if (avail) avail.textContent = v.available ? '' : 'Diese Variante ist aktuell nicht verfügbar.';
        scope.querySelectorAll('[data-bc-add]').forEach(function (b) {
          if (!b.hasAttribute('data-variant-id')) b.disabled = !v.available;
        });
        if (v.mediaIndex != null) goTo(v.mediaIndex);
        renderBundles();
        renderColors();
        var sImg = scope.querySelector('[data-bc-sticky-img]');
        if (sImg && v.image) sImg.src = v.image;
        var hid = scope.querySelector('[data-bc-form-id]');
        if (hid) hid.value = v.id;
      }
      function setQty(n) {
        n = Math.max(1, Math.min(99, n || 1));
        if (qtyInput) qtyInput.value = n;
        scope.setAttribute('data-current-qty', n);
        var sel = scope.querySelector('[data-bc-bundle-row][data-qty="' + n + '"]');
        scope.querySelectorAll('[data-bc-bundle-row]').forEach(function (r) {
          r.classList.toggle('is-sel', r === sel);
          r.setAttribute('aria-checked', r === sel ? 'true' : 'false');
        });
        renderBundles();
      }

      if (colorWrap) {
        colorWrap.addEventListener('click', function (e) {
          var b = e.target.closest('[data-vid]'); if (!b) return;
          var v = variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
          setVariant(v);
        });
      }
      if (sizeSel) {
        sizeSel.addEventListener('change', function () {
          var list = availableColors(sizeSel.value);
          var same = list.filter(function (v) { return v.color === current.color; })[0];
          setVariant(same || list[0]);
        });
      }
      scope.querySelectorAll('[data-bc-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          setQty((parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) + parseInt(b.getAttribute('data-bc-qty-step'), 10));
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10) || 1); });
      scope.addEventListener('click', function (e) {
        var row = e.target.closest('[data-bc-bundle-row]');
        if (!row) return;
        setQty(parseInt(row.getAttribute('data-qty'), 10) || 1);
      });
      scope.addEventListener('keydown', function (e) {
        var row = e.target.closest('[data-bc-bundle-row]');
        if (!row) return;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); row.click(); }
      });

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      scope.querySelectorAll('[data-bc-gal-nav]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!track) return;
          var w = track.clientWidth;
          var i = Math.round(track.scrollLeft / w) + parseInt(b.getAttribute('data-bc-gal-nav'), 10);
          i = Math.max(0, Math.min(track.children.length - 1, i));
          goTo(i);
        });
      });
      if (track) {
        var t0 = null;
        track.addEventListener('scroll', function () {
          clearTimeout(t0);
          t0 = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 90);
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); var n = scope.querySelector('[data-bc-gal-nav="1"]'); if (n) n.click(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); var p2 = scope.querySelector('[data-bc-gal-nav="-1"]'); if (p2) p2.click(); }
        });
      }

      var pform = scope.querySelector('[data-bc-form] form') || scope.querySelector('form[action*="/cart/add"]');
      if (pform) {
        pform.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = pform.querySelector('[data-bc-add]');
          addToCart(current.id, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, btn);
        });
      }

      var sticky = scope.querySelector('[data-bc-sticky]');
      var anchor = scope.querySelector('[data-bc-sticky-anchor]');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(anchor);
      }

      setVariant(variants[0]);
      setQty(1);
      setActive(0);
    });
  }

  function chipsInit(root) {
    (root || document).querySelectorAll('[data-bc-chips]:not([data-chips-done])').forEach(function (box) {
      box.setAttribute('data-chips-done','');
      var target = document.getElementById(box.getAttribute('data-bc-chips'));
      if (!target) return;
      box.addEventListener('click', function (e) {
        var c = e.target.closest('[data-cat]'); if (!c) return;
        box.querySelectorAll('[data-cat]').forEach(function (x) {
          var on = x === c;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var cat = c.getAttribute('data-cat');
        target.querySelectorAll('[data-item-cat]').forEach(function (it) {
          it.classList.toggle('bc-hidden', cat !== 'all' && it.getAttribute('data-item-cat') !== cat);
        });
      });
    });
  }

  function footerInit() {
    var mq = window.matchMedia('(max-width: 989px)');
    document.querySelectorAll('[data-bc-ft-col]:not([data-ft-done])').forEach(function (col) {
      col.setAttribute('data-ft-done','');
      var btn = col.querySelector('[data-bc-ft-btn]');
      var panel = col.querySelector('[data-bc-ft-panel]');
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded','false');
      btn.addEventListener('click', function () {
        if (!mq.matches) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
      });
      var sync = function () {
        panel.style.height = mq.matches ? (col.classList.contains('is-open') ? panel.scrollHeight + 'px' : '0px') : '';
      };
      if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
      sync();
    });
  }

  function boot(root) {
    reveal(root); tilt(root); accordionInit(root); productInit(root); chipsInit(root); annInit();
  }
  function init() { boot(document); headerInit(); footerInit(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); headerInit(); footerInit(); });
})();
